(function($) {
    class W4D_StickyHeader {
        constructor() {
            this.init();
        }

        init() {
            this.$header = $('.w4d-header');
            this.lastScrollTop = 0;
            this.delta = 5;
            this.bindEvents();
        }

        bindEvents() {
            $(window).on('scroll', () => {
                if (!this.$header.hasClass('w4d-header--sticky')) {
                    return;
                }

                if ($('body').hasClass('dgwt-wcas-open')) {
                    return;
                }

                if ($('nav:not([data-header-type="3"]) .nav__links-wrapper:has(.nav__item--submenu-open)').length) {
                    return;
                }

                this.handleScroll();
            });

            $(window).on('resize', () => {
                this.headerHeight = this.$header.outerHeight();
            });
        }

        handleScroll() {
            const scrollTop = $(window).scrollTop();
            const headerHeight = this.$header.outerHeight();

            if (scrollTop > headerHeight && scrollTop > this.lastScrollTop && Math.abs(this.lastScrollTop - scrollTop) > this.delta) {
                this.$header.addClass('w4d-header--hidden');
            } else if (scrollTop < this.lastScrollTop && Math.abs(this.lastScrollTop - scrollTop) > this.delta) {
                this.$header.removeClass('w4d-header--hidden');
            }

            this.lastScrollTop = scrollTop;
        }
    }

    $(document).ready(() => new W4D_StickyHeader());
})(jQuery);